
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/miniSite/search",
      function () {
        return require("private-next-pages/miniSite/search/index.miniSite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/miniSite/search"])
      });
    }
  